import { useLocation } from "react-router-dom"
import type { Provider } from "./AvailableProvidersPage"
import PencomTextField from "@/components/input/PencomTextField"
import { PrimaryButton } from "@/components/buttons/PrimaryButton"

export const RequestCallBackPage = () => {
    const { provider } = useLocation().state as { provider: Provider }
    console.log({ provider })
    return <div className="w-full flex flex-col min-h-screen">
        <div className="w-full flex flex-col items-center justify-center  max-w-[460px] mx-auto mt-6">
            <div className="flex flex-col gap-y-4 items-center justify-center mt-8">
                <h2 className="font-clash-display text-2xl font-semibold text-medium-dark-grey">{provider.name}</h2>
                <p className="font-clash-display text-sm font-regular text-medium-dark-grey">Provide your details and a company rep will contact you.</p>
            </div>
            <div className="mt-8 gap-y-6 flex flex-col w-full">
                <PencomTextField id="company-nae" label="Company Name" value="" onChange={() => { }} type="text" />
                <PencomTextField id="no-of-employees" label="Number of Employees" value="" onChange={() => { }} type="text" />
                <PencomTextField id="email-address" label="Email Address" value="" onChange={() => { }} type="email" />
                <PencomTextField id="phone-number" label="Phone Number" value="" onChange={() => { }} type="tel" />
                <PencomTextField id="comments" multiline label="Coments (Optional)" value="" onChange={() => { }} type="text" />
            </div>
            <PrimaryButton className="mt-10 w-full" title="Submit" onClick={() => { }} />
        </div>
    </div>
}